module.exports = __webpack_public_path__ + "img/dashcard.old..bc86d742.svg";